import {
    PARTY_FIELDS,
    ADDITIONAL_EMAIL_FIELD,
    IS_PUBLIC_FIELD,
    ATTACHMENT_FIELD,
    FEE_OPTION_FIELD,
    CONFIRMATION_NUM_FIELD,
    EMAIL_FIELD,
    COUNTRY_FIELD,
    RECORDATION_OPTION_FIELD,
    RECORDATION_DATE_OF_AGREEMENT_FIELD,
    RECORDATION_OPTIONS,
    PRIMARY_RECORDATION_NUM_FIELD,
    DOCKET_NUM_FIELDS,
    EQUIPMENT_DESCRIPTION_FIELD,
    STATE_FIELD,
    FILE_FIELD,
    PHONE_FIELD,
    FAX_FIELD,
    OTHER_PARTY_TYPE_FIELD,
    PARTY_TYPE_FIELD,
    REGION_FIELD,
    RECORDATION_FORM_TYPE,
    ENVIRONMENTAL_COMMENTS_FORM_TYPE,
    ENVCOM_HAVE_DOCKETS_FIELD,
    FORMAL_FILING_FORM_TYPE,
    EFILING_SUBMIT_CHECKBOX_FIELD
} from "../../../resources/constants/fields";
import {
    validateFile,
    validateEmail,
    validateAllParties,
    validateAllFiles,
    clearFieldError,
    validateDateField,
    isValidPrimaryRecordationFormat,
    validateRecordationNumField,
    validateDocketNumbers,
    validateFieldLength,
    validatePhoneNumber
} from "./validation";
import {
    FEE_OPTIONS,
    COUNTRIES,
    DOCKET_PREFIXES
} from "../../../resources/constants/dropdowns";
import {
    INVALID_EMAIL_ERROR,
    INVALID_ADDITIONAL_EMAIL_ERROR,
    getMaxFieldLengthError,
    INVALID_PHONE_NUMBER_ERROR,
    INVALID_FAX_NUMBER_ERROR,
    INVALID_PRIMARY_RECORDATION_FORMAT_ERROR
} from "../../../resources/constants/errors";
import {
    MAX_EQUIPMENT_DESCRIPTION_LENGTH,
    hasValue,
    PARTY_LIMITS,
    RCPA_FIELD_LENGTHS,
    ENV_COM_FIELD_LENGTHS
} from "../../../resources/constants/validations";
import FilingParty from "../components/FilingParty";
import FileAttachment from "../components/FileAttachment";
import { REGION_HINT_ID } from "../../../resources/constants/ui";


const reducer = (state, action) => {
    switch (action.type) {
        case "setState":
            return {...state, ...action.newState};
        case 'handleChange':
            return handleChange(state, action.event);
        case "handleBlur":
           return handleBlur(state, action.event);
        case "clearDate":
            return clearDate(state);
        case "addDocketNumber":
            return addDocketNumber(state);
        case "removeDocketNumber":
            return removeDocketNumber(state, action.index);
        case "addParty":
            return addParty(state);
        case "removeParty":
            return removeParty(state, action.partyIndex)
        case "addEmail":
            return addEmail(state, action.partyIndex);
        case "removeEmail":
            return removeEmail(state, action.partyIndex, action.emailIndex);
        case "clickAttachment":
            clickAttachment(action.event);
            return state;
        case "addAttachment":
            return addAttachment(state);
        case "removeAttachment":
            return removeAttachment(state, action.index);
        default:
            return state;
    }
}

const clearDate = (state) => {
    let newState = {...state};
    document.getElementsByName(RECORDATION_DATE_OF_AGREEMENT_FIELD)[0].value = null;
    newState = validateDateField(state, RECORDATION_DATE_OF_AGREEMENT_FIELD);
    return newState;
}

const addDocketNumber = (state) => {
    let newState = {...state};
    newState.data.docketNumbers = [
        ...state.data.docketNumbers, 
        {
            docketPrefix: DOCKET_PREFIXES[0],
            sequenceNumber: "",
            subSequenceNumber: "",
            docketSuffix: ""
        }
    ];
    return newState;
}

const removeDocketNumber = (state, index) => {
    var newState = {...state};
    let docketNumbers = [...state.data.docketNumbers];
    let newArr = docketNumbers.slice(0, index);
    let newArr2 = docketNumbers.slice(
        index + 1,
        docketNumbers.length
    );
    docketNumbers = [...newArr, ...newArr2];
    newState.data.docketNumbers =  docketNumbers;
    newState.form.errors = validateDocketNumbers(
        {
            docketNumbers: docketNumbers,
            errors: state.form.errors
        },
        false
    );
    return newState;
}


const addParty = state => {
    let newState = {...state}
    if(state.data.parties.length < PARTY_LIMITS[state.form.type].max){
        newState.data.parties.push(new FilingParty());
    }
    return newState;
}

const removeParty = (state, partyIndex) => {
    let newState = {...state}
    if(state.data.parties.length > PARTY_LIMITS[state.form.type].min){
        newState.data.parties = newState.data.parties.filter((value, index) => index !== Number(partyIndex))
        newState.form.errors = validateAllParties(
            newState.form,
            newState.data.parties,
            false
        )
    }
    return newState;
}

const addEmail = (state, partyIndex) => {
    let newState = {...state};
    let parties = [...newState.data.parties];
    let party = parties[partyIndex];
    let emails = [...party.state.additionalEmails, ''];

    party.state.additionalEmails = emails;
    parties[partyIndex] = party;

    newState.data.parties= parties;
    return newState;
};

const removeEmail = (state, partyIndex, emailIndex) => {
    let newState = {...state};
    let parties = [...newState.data.parties];
    let party = parties[partyIndex];

    let newArr = party.state.additionalEmails.slice(0, emailIndex + 1);
    let newArr2 = party.state.additionalEmails.slice(
        emailIndex + 1,
        party.state.additionalEmails.length
    );
    newArr.pop();
    party.state.additionalEmails = [...newArr, ...newArr2];
    parties[partyIndex] = party;
    newState.data.parties = parties;

    let targetPartyEmails = `${ADDITIONAL_EMAIL_FIELD}-${partyIndex}`;
    newState.form.errors = newState.form.errors.filter(
        error => !error.fieldId.includes(targetPartyEmails)
    );

    for(var email in party.state.additionalEmails) {
        let emailValue = party.state.additionalEmails[email];
        if(
            hasValue(emailValue) &&
            validateEmail(party.state.additionalEmails[email]) === false
        ) {
            newState.form.errors.push(
                {
                    errorMsg: INVALID_ADDITIONAL_EMAIL_ERROR,
                    fieldId: `${ADDITIONAL_EMAIL_FIELD}-${partyIndex}-${email}`
                }
            );
        }
    }
    return newState;
};

const handleChange = (state, event) => {
    const OBJECT_STATE = 'state';
    let newState = {...state};
    newState.form.networkErrors = [];

    let targetId = event.target.id;
    let targetIdArray = targetId.split("-");
    let targetFieldName = targetIdArray[0];
    let targetIdPrimaryIndex, targetIdSecondaryIndex;
    if(targetIdArray.length > 1) {
        targetIdPrimaryIndex = targetIdArray[1];
        if(targetIdArray.length > 2) {
            targetIdSecondaryIndex = targetIdArray[2];
        }
    }
    let targetValue = event.target.value;

    if(PARTY_FIELDS.includes(targetFieldName)) {
        let newData;
        let isPartyArray = newState.data.parties && hasValue(targetIdPrimaryIndex);
        if(isPartyArray) {
            newData = newState.data.parties[targetIdPrimaryIndex][OBJECT_STATE];
        } else {
            newData = newState.data;
        }
        let countryChanged = targetFieldName === COUNTRY_FIELD;
        if(countryChanged) {
            let countryChangedToUS = targetValue === COUNTRIES[0];
            let countryChangedFromUS = newData[COUNTRY_FIELD] === COUNTRIES[0];
            if(countryChangedToUS || countryChangedFromUS) {
                newData[STATE_FIELD] = "";
            }
        }
        let partyTypeChanged = targetFieldName === PARTY_TYPE_FIELD;
        if(partyTypeChanged) {
            newData[OTHER_PARTY_TYPE_FIELD] = "";
        }
        if (
            targetFieldName === ADDITIONAL_EMAIL_FIELD && 
            hasValue(targetIdPrimaryIndex) && hasValue(targetIdSecondaryIndex)
        ) {
            //primary index is for party array, secondary index is for additional email array
            newState.data.parties[targetIdPrimaryIndex][OBJECT_STATE][ADDITIONAL_EMAIL_FIELD][targetIdSecondaryIndex] = targetValue;
        } else {
            newData[targetFieldName] = targetValue;
        }
        if(isPartyArray) {
            newState.data.parties[targetIdPrimaryIndex][OBJECT_STATE] = newData;
        } else {
            newState.data = newData;
        }
    } else if (DOCKET_NUM_FIELDS.includes(targetFieldName)) {
        //primary index is for docket number array
        newState.data.docketNumbers[targetIdPrimaryIndex][targetFieldName] = targetValue;
    } else if (event.target.className === IS_PUBLIC_FIELD) {
        let isPublic = targetValue === "true";
        newState.data.isPublic[targetIdPrimaryIndex] = isPublic;
    } else if (targetFieldName === ATTACHMENT_FIELD) {
        let file = event.target.files[0];
        //primary index is for attachment array
        newState.data.attachments[targetIdPrimaryIndex][OBJECT_STATE][FILE_FIELD] = file;
        if(newState.form.type === RECORDATION_FORM_TYPE) {
            newState.form.errors = validateFile(
                file,
                event.target.id,
                newState.form.errors,
                newState.data.attachments,
                true
            );
        } else if(newState.form.type === ENVIRONMENTAL_COMMENTS_FORM_TYPE) {
            newState.form.errors = validateFile(
                file,
                event.target.id,
                newState.form.errors,
                newState.data.attachments,
                null,
                ENVIRONMENTAL_COMMENTS_FORM_TYPE
            );
        } else if (newState.form.type === FORMAL_FILING_FORM_TYPE){
            newState.form.errors = validateFile(
                file,
                event.target.id,
                newState.form.errors,
                newState.data.attachments,
                null,
                FORMAL_FILING_FORM_TYPE
            );
        }
        else {
            newState.form.errors = validateFile(
                file,
                event.target.id,
                newState.form.errors,
                newState.data.attachments
            );
        }
    } else if (targetFieldName === RECORDATION_DATE_OF_AGREEMENT_FIELD) {
        newState.data[targetFieldName] = targetValue;
        newState = validateDateField(newState, RECORDATION_DATE_OF_AGREEMENT_FIELD);
    } else if (targetFieldName === PRIMARY_RECORDATION_NUM_FIELD) {
        newState.data[targetFieldName] = targetValue;
        newState = validateRecordationNumField(newState, PRIMARY_RECORDATION_NUM_FIELD);
    } else if (targetFieldName === RECORDATION_OPTION_FIELD) {
        let primaryRecordation = RECORDATION_OPTIONS[0].value;
        newState = clearFieldError(newState, RECORDATION_OPTION_FIELD);
        if(targetValue === primaryRecordation) {
            newState = clearFieldError(newState, PRIMARY_RECORDATION_NUM_FIELD);
            newState.data[PRIMARY_RECORDATION_NUM_FIELD]= "";
        }
        newState.data[targetFieldName]= targetValue;
    } else if (targetFieldName === FEE_OPTION_FIELD) {
        let noFeeRequired = FEE_OPTIONS[2].value;
        if(targetValue === noFeeRequired) {
            newState = clearFieldError(newState, CONFIRMATION_NUM_FIELD);
            newState.data[CONFIRMATION_NUM_FIELD] = "";
        }
        newState.data[targetFieldName] = targetValue;
    } else if (targetFieldName === REGION_FIELD) {
        newState = clearFieldError(newState, REGION_FIELD);
        newState.data[targetFieldName] = targetValue;
    } else if (targetFieldName === ENVCOM_HAVE_DOCKETS_FIELD) {
        newState = clearFieldError(newState, ENVCOM_HAVE_DOCKETS_FIELD);
        newState.data[targetFieldName] = targetValue;
        if (targetValue === "true") {
            if (!newState.data.docketNumbers || newState.data.docketNumbers.length === 0) {
                addDocketNumber(newState);
            }
        } else {
            if (newState.data.docketNumbers && newState.data.docketNumbers.length > 0) {
                newState.data.docketNumbers = [];
                newState.form.errors =  validateDocketNumbers(
                    {
                        docketNumbers: newState.data.docketNumbers,
                        errors: newState.form.errors
                    },
                    false
                );
            }
        }
    } else if (targetFieldName === EFILING_SUBMIT_CHECKBOX_FIELD) {
        newState = clearFieldError(newState, EFILING_SUBMIT_CHECKBOX_FIELD);
        newState.data[targetFieldName] = event.target.checked;
    }
    else {
        newState.data[targetFieldName] = targetValue;
    }
    if(targetFieldName === REGION_FIELD) {
        document.getElementById(REGION_HINT_ID).style.display = "none";
    }
    return newState;
}

const handleBlur = (state, event) => {
    let newState = {...state};

    let targetId = event.target.id;
    let targetIdArray = targetId.split("-");
    let targetFieldName = targetIdArray[0];
    let targetValue = event.target.value;

    let notEmpty = hasValue(targetValue);
    let errorMessage = "";

    let errors = newState.form.errors;
    //Filter out errors for this field to re-validate
    errors = errors.filter(
        error => error.fieldId !== targetId
    );
    
    if(notEmpty){
        if (
            targetFieldName === PHONE_FIELD &&
            !validatePhoneNumber(targetValue)
        ) {
            errors.push(
                {
                    errorMsg: INVALID_PHONE_NUMBER_ERROR,
                    fieldId: targetId,
                    targetValue: targetValue
                }
            );
        } else if (
            targetFieldName === PRIMARY_RECORDATION_NUM_FIELD &&
            !isValidPrimaryRecordationFormat(targetValue)
        ) {
            errors.push(
                {
                    errorMsg: INVALID_PRIMARY_RECORDATION_FORMAT_ERROR,
                    fieldId: targetId,
                    targetValue: targetValue
                }
            );
        } else if (
            targetFieldName === FAX_FIELD &&
            !validatePhoneNumber(targetValue)
        ) {
            errors.push(
                {
                    errorMsg: INVALID_FAX_NUMBER_ERROR,
                    fieldId: targetId,
                    targetValue: targetValue
                }
            );
        } else if (
            targetFieldName === EMAIL_FIELD &&
            validateEmail(targetValue) === false
        ) {
            if([RECORDATION_FORM_TYPE, ENVIRONMENTAL_COMMENTS_FORM_TYPE].includes(state.form.type)) {
                errors.push(
                    {
                        errorMsg: INVALID_ADDITIONAL_EMAIL_ERROR,
                        fieldId: targetId,
                        targetValue: targetValue
                    }
                );
            } else {
                errors.push(
                    {
                        errorMsg: INVALID_EMAIL_ERROR,
                        fieldId: targetId,
                        targetValue: targetValue
                    }
                );
            }
        } else if (
            targetFieldName === ADDITIONAL_EMAIL_FIELD &&
            validateEmail(targetValue) === false
        ) {
            errors.push(
                {
                    errorMsg: INVALID_ADDITIONAL_EMAIL_ERROR,
                    fieldId: targetId,
                    targetValue: targetValue
                }
            );
        } else if (
            DOCKET_NUM_FIELDS.includes(targetFieldName)
        ) {
            errors = validateDocketNumbers(
                {
                    docketNumbers: state.data.docketNumbers, 
                    errors: errors
                }, 
                false
            );
        } else if(
            targetFieldName === EQUIPMENT_DESCRIPTION_FIELD && 
            !validateFieldLength(targetValue, MAX_EQUIPMENT_DESCRIPTION_LENGTH)
        ) {
            errorMessage = getMaxFieldLengthError(MAX_EQUIPMENT_DESCRIPTION_LENGTH, String(targetValue).length);
            errors.push(
                {
                    errorMsg: errorMessage,
                    fieldId: targetId
                }
            );
        }
        // Always run field length validations
        if(
            RCPA_FIELD_LENGTHS[targetFieldName]
        ) {
            if(!validateFieldLength(targetValue, RCPA_FIELD_LENGTHS[targetFieldName])) {
                errorMessage = getMaxFieldLengthError(RCPA_FIELD_LENGTHS[targetFieldName], String(targetValue).length);
                errors.push(
                    {
                        errorMsg: errorMessage,
                        fieldId: targetId
                    }
                );
            }
        } else if(
            ENV_COM_FIELD_LENGTHS[targetFieldName]
        ) {
            if(!validateFieldLength(targetValue, ENV_COM_FIELD_LENGTHS[targetFieldName])) {
                errorMessage = getMaxFieldLengthError(ENV_COM_FIELD_LENGTHS[targetFieldName], String(targetValue).length);
                errors.push(
                    {
                        errorMsg: errorMessage,
                        fieldId: targetId
                    }
                );
            }
        }
    }
    newState.form.errors = errors;
    return newState;
}

const clickAttachment = event => {
    event.target.value = "";
};

const addAttachment = state => {
    let newState = {...state};

    newState.data.attachments= [...newState.data.attachments, new FileAttachment()];
    newState.data.isPublic= [...newState.data.isPublic, true];
    return newState;
}

const removeAttachment = (state, index) => {
    let newState = {...state};
    let newArr = newState.data.attachments.slice(0, index);
    let newArr2 = newState.data.attachments.slice(
        index + 1,
        newState.data.attachments.length
    );
    newArr = [...newArr, ...newArr2];
    newState.data.attachments= newArr;

    //remove isPublic from array
    newArr = newState.data.isPublic.slice(0, index);
    newArr2 = newState.data.isPublic.slice(
        index + 1,
        newState.data.isPublic.length
    );
    newArr = [...newArr, ...newArr2];
    newState.data.isPublic= newArr;

    newState.form.errors= validateAllFiles(
        state.form.errors,
        state.data.attachments,
        state.form.type
    )
    return newState;
};

export default reducer;
